<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.EMAIL_BUILDER.EDIT_EMAIL' | translate }}
    </glxy-page-title>
    <glxy-page-actions>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <email-builder-page />
</glxy-page>
